module.exports = `
<div class="modal-content policy-font">
        <div class="modal-body">
                <p class=MsoNormal align=center style='margin-bottom:7.5pt;text-align:center;
line-height:19.2pt;background:white'><b><span style='font-size:12.0pt;
font-family:"Source Sans Pro","sans-serif";color:#777777'>VERİ İŞLEME
SÖZLEŞMESİ</span></b></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>İşbu veri işleme sözleşmesi (“<b>Sözleşme</b>”),</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>kendi ve İştirak'leri (aşağıda tanımlandığı şekliyle) adına
hareket eden ve ticari merkezi &quot;Ağaoğlu My Office İş Merkezi Barbaros Mah.
Lale Sok. No 2 Zemin Kat Bölüm 8 Ataşehir-İstanbul&quot; adresinde bulunan
Otosor Otomotiv A.Ş. (&quot;Veri Sorumlusu&quot;) ile</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>Otosor ile araç alım/satımı kapsamında hukuki ve ticari bir
ilişki (&quot;İş İlişkisi&quot;) tesis etmek niyetinde olan ilgili kullanıcı
(&quot;Veri İşleyen&quot;) arasında akdedilmiştir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>İşbu Sözleşme, Veri Sorumlusu ile Veri İşleyen arasında İş
İlişkisi kurulabilmesi için akdedilen Üyelik Sözleşmesi'nin (&quot;Asıl
Sözleşme&quot;) eki ve ayrılmaz bir parçası olarak düzenlenmiştir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>İşbu Sözleşme'de Veri Sorumlusu ve Veri İşleyen ayrı ayrı
&quot;Taraf&quot;, birlikte ise &quot;Taraflar&quot; olarak anılacaktırlar.</span></p>

                <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
normal;background:white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>&nbsp;</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>1. Tanımlar</span></b></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>İşbu Sözleşme'de kullanılan terimler, aşağıda kendilerine
atfedilen anlamı taşıyacaktırlar:</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>&quot;Alt İşleyici&quot;</span></b><span style='font-size:12.0pt;
font-family:"Source Sans Pro","sans-serif";color:#777777'>&nbsp;Veri İşleyen
tarafından görevlendirilen veya Veri İşleyen'in herhangi başka bir alt
işleyicisi tarafından görevlendirilen ve fakat her hâlükârda Veri Sorumlusu'nun
talimatlarına uygun olarak veri işleyen kişiyi ifade etmektedir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>&quot;Asıl Sözleşme&quot;</span></b><span style='font-size:12.0pt;
font-family:"Source Sans Pro","sans-serif";color:#777777'>&nbsp;Veri Sorumlusu
ile Veri İşleyen arasında İş İlişkisi'nin kurulması için akdedilen tarihinde
akdedilmiş Üyelik Sözleşmesi'ni ifade etmektedir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>&quot;işlemek&quot;</span></b><span style='font-size:12.0pt;
font-family:"Source Sans Pro","sans-serif";color:#777777'>&nbsp;işbu terime
KVKK'da atfedilen anlamı ifade etmektedir ve &quot;işleme&quot;,
&quot;işlerse&quot;, &quot;işlendiğinde&quot; ve benzer ifadeler de aynı
şekilde yorumlanacaktır.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>&quot;İştirak&quot;</span></b><span style='font-size:12.0pt;
font-family:"Source Sans Pro","sans-serif";color:#777777'>&nbsp;Taraflar'dan
herhangi birinin tamamen veya kısmen, doğrudan veya dolaylı olarak sahipliğinde
veya kontrolünde bulunan bir kuruluşu ifade etmektedir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>&quot;Kurul&quot;</span></b><span style='font-size:12.0pt;
font-family:"Source Sans Pro","sans-serif";color:#777777'>&nbsp;Kişisel
Verileri Koruma Kurulu'nu ifade etmektedir</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>&quot;KVKK&quot;</span></b><span style='font-size:12.0pt;
font-family:"Source Sans Pro","sans-serif";color:#777777'>&nbsp;ileride
yürürlüğe girebilecek her türlü değişiklik veya ilave ile birlikte kişisel
verilerin işlenmesine ilişkin bireylerin korunması hakkında 6698 sayılı Kişisel
Verilerin Korunması Kanunu'nu ve bunun yürürlükteki tüm ikincil düzenlemelerini
ifade etmektedir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>&quot;Taraf&quot;</span></b><span style='font-size:12.0pt;
font-family:"Source Sans Pro","sans-serif";color:#777777'>&nbsp;veya
&quot;Taraflar&quot; işbu terimlere işbu Sözleşme'nin giriş bölümünde atfedilen
anlamları ifade etmektedirler.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>&quot;Veri Sorumlusu&quot;, &quot;Veri İşleyen&quot;,
&quot;İlgili Kişi&quot; ve &quot;Kişisel Veri&quot;</span></b><span
                        style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";color:#777777'>&nbsp;işbu
terimlere KVKK'da atfedilen anlamları ifade etmektedirler.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>&quot;Veri Vakası&quot;</span></b><span style='font-size:12.0pt;
font-family:"Source Sans Pro","sans-serif";color:#777777'>&nbsp;aşağıda sayılan
anlamların birini veya tümünü ifade etmektedir:</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(i) Kişisel Veri'nin arızi ve/veya hukuka aykırı bir şekilde yok
edilmesi veya kaybedilmesi;</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(ii) Kişisel Veri'nin yetkisiz ve/veya hukuka aykırı bir şekilde
toplanması, kullanılması, kopyalanması, değiştirilmesi, ortadan kaldırılması,
ifşa edilmesi veya erişilmesi veya bunlara benzer riskler ve;</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(iii) KVKK'da düzenlenmiş diğer tüm hukuka aykırı işleme
yöntemleri ve ihlal teşkil edecek durumlar.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>2.Kişisel Veri'nin İşlenmesi</span></b></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>2.1 Kapsam. İşbu Sözleşme, Veri Sorumlusu'nun Asıl Sözleşme
kapsamında belirlediği amaç ve vasıtalar uyarınca Veri İşleyen'in edindiği
üçüncü kişilere ait Kişisel Veri'nin Veri İşleyen tarafından işlenmesi halinde
uygulanır. Taraflar, işbu Sözleşme'nin amacına uygun olarak, Veri Sorumlusu'nun
söz konusu Kişisel Veri'ler nezdinde KVKK'da tanımlandığı şekliyle Veri Sorumlusu
olduğunu ve Veri İşleyen'in söz konusu veriler nezdinde KVKK'da tanımlandığı
şekliyle Veri İşleyen olduğunu kabul etmektedirler.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>2.2 Talimatlar. Veri İşleyen, Kişisel Veri'yi Veri Sorumlusu
adına, KVKK dahil fakat bununla sınırlı olmaksızın uygulanabilir mevzuata, Veri
Sorumlusu'nun talimatlarına ve işbu Sözleşme'ye tamamen uygun bir şekilde
işleyecektir. İşbu Sözleşme ve Asıl Sözleşme Veri Sorumlusu'nun Veri İşleyen'e
ön talimatlarını içermektedir. İşbu Sözleşme kapsamı dışındaki herhangi bir
işleme, Taraflar'ın mutabakatına tabidir. Veri İşleyen, ne sebeple olursa olsun
mevzuata, Veri Sorumlusu'nun talimatlarına veya işbu Sözleşme ve/veya Asıl
Sözleşme'ye uygunluk sağlayamadığı ve/veya sağlayamayacağı takdirde, Veri
Sorumlusu'nu bu hususa ilişkin derhal bilgilendirecektir. Böyle bir durumda
Veri İşleyen, Veri Sorumlusu'nun Kişisel Veri aktarımını askıya alma ve/veya
işbu Sözleşme'yi ve/veya Asıl Sözleşme'yi feshetme hakkını haiz olduğunu
peşinen kabul etmektedir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>2.3 Kişisel Veri'nin İşlenme Amacı ve/veya Süresi. Veri İşleyen,
Kişisel Veri'yi işlerken, işbu Kişisel Veri'yi her zaman KVKK'ya ve işbu
Sözleşme'ye uygun olarak ve Veri Sorumlusu'nun bu husustaki talimatları
doğrultusunda, işleme amacının gerektirdiği ölçüde işleyecektir ve işlemeyi
gereken azami süre ile kısıtlı tutacaktır. Kişisel Veri'yi işleme amacının
ortadan kalkması durumunda ve/veya Kişisel Veri'yi işleme süresinin dolması
durumunda Veri İşleyen, Kişisel Veri'yi tüm kopyaları ve yedekleri ile birlikte
Veri Sorumlusu'nun talimatı üzerine veya resen, KVKK'da öngörüldüğü şekilde
derhal silecek, yok edecek veya anonim hale getirecektir ve Alt İşleyici'lerin
de söz konusu Kişisel Veri'yi silmeleri, yok etmeleri veya anonim hale
getirmeleri adına gerekli tüm adımları atacaktır. Bu bağlamda Veri İşleyen,
Kişisel Verilerin Silinmesi, Yok Edilmesi veya Anonim Hale Getirilmesi Hakkında
Yönetmelik ile getirilen periyodik imha yükümlülüğü çerçevesinde, kendisi
tarafından belirlenmiş aralıklarla, Kişisel Veri'nin işlenme amacının ortadan
kalkıp kalkmadığını ve/veya işleme süresinin dolup dolmadığını düzenli olarak
kontrol edeceğini taahhüt etmektedir. Veri İşleyen'in veya Alt İşleyici'nin
işbu maddede belirtilen yükümlülüklerini mevzuat uyarınca yerine getirmesinde
herhangi bir engel olması durumunda Veri İşleyen veya Alt İşleyici, Kişisel
Veri'yi işleme faaliyetlerini derhal durduracağını ve Kişisel Veri'nin
gizliliğini ve güvenliğini temin etmek adına gerekli tüm teknik, kurumsal ve
idari tedbirleri alacağını kabul ve taahhüt etmektedir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>2.4 Kişisel Veri'nin Paylaşım Şekli. Kişisel Veri, Veri İşleyen
tarafından fiziksel ortamda ve/veya e-posta, sunucu (server), bulut (cloud)
ortamları da dahil fakat bununla sınırlı kalmaksızın elektronik ortamda
paylaşılabilecektir.</span></p>

                <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
normal;background:white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>&nbsp;</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>3. Alt İşleyici'ler</span></b></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>3.1 Veri İşleyen bir Alt İşleyici atamak istediği takdirde,
aşağıda sayılanlara uymak zorundadırlar:</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(i) yeni alt işleyici hakkında uygun hukuki inceleme
gerçekleştirecektir ve belgeleyecektir;</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(ii) yeni alt işleyiciye Kişisel Veri'ye erişim hakkı vermeden
en az otuz (30) gün önce yazılı bir bildirim vasıtasıyla yeni alt işleyicinin
detaylarını, Kişisel Veri'ye ilişkin faaliyetlerini ve gerçekleştirilen hukuki
inceleme kapsamında elde edilen tüm esaslı bulguları Veri Sorumlusu'na
sağlayacaktır;</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(iii) Veri Sorumlusu'nun yeni alt işleyiciye onay vermesi
durumda yeni alt işleyici ile akdedilmiş ve asgari olarak ilgili yeni alt
işleyicinin, Veri İşleyen'in işbu Sözleşme'den, Asıl Sözleşme'den ve KVKK dahil
ancak bununla sınırlı olmaksızın uygulanabilir tüm mevzuattan kaynaklı
yükümlülükleri ve sorumluluklarına uyum sağlaması adına gerekli hükümleri
içerecek olan Kişisel Veri'nin korunmasına ilişkin anlaşmayı Veri Sorumlusu'na
sağlayacaktır;</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(iv) Veri Sorumlusu'nun, verilerin korunmasına ilişkin makul
ölçüdeki endişelerinden dolayı onay vermemesi durumunda, Veri Sorumlusu Veri
İşleyen'e reddini bildirecek olup işbu bildirimde verilerin korunmasına ilişkin
endişelerini ayrıntıları ile belirtecektir. Bu durumda Veri İşleyen, Veri
Sorumlusu'nu tatmin edecek bir çözüm bulmadan önce, Veri Sorumlusu'ndan aldığı
Kişisel Veri'nin söz konusu yeni alt işleyici tarafından işlenmesine izin
vermeyecektir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>Şüpheye mahal vermemek adına; yeni bir alt işleyici, ancak Veri
Sorumlusu tarafından işbu madde 3'e göre onaylandığı takdirde Kişisel Veri'leri
işlemeye yetkilendirilmiş sayılacak olup ancak o noktadan sonra işbu Sözleşme
kapsamında &quot;Alt İşleyici&quot; sıfatını haiz olacaktır.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>3.2 Alt İşleyici'ler Bakımından Yükümlülükler. Veri Sorumlusu
herhangi bir Alt İşleyici'yi Veri İşleyen'in İştirak'leri dahil) işbu madde
3'te belirtildiği şekilde yetkilendirdiği takdirde:</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(i) Veri İşleyen Alt İşleyici'nin Kişisel Veri'ye erişimini,
Veri İşleyen'in işbu Sözleşme kapsamındaki yükümlülüklerini yerine
getirebilmesi adına gerekli olanla sınırlayacaktır ve Alt İşleyici'lerin
Kişisel Veri'ye herhangi farklı bir sebepten dolayı erişimi yasaklanacaktır;</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(ii) Veri İşleyen tüm Alt İşleyici'lere yazılı bir şekilde ve en
az işbu Sözleşme'nin, Asıl Sözleşme'nin ve KVKK dahil ancak bununla sınırlı
olmaksızın uygulanabilir tüm mevzuat hükümleri kadar koruyucu olan sözleşmesel
yükümlülükler getirecektir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(iii) Veri İşleyen, işbu Sözleşme, Asıl Sözleşme ve KVKK dahil
ancak bununla sınırlı olmaksızın uygulanabilir tüm mevzuat hükümleri kapsamında
Veri İşleyen için getirilen tüm yükümlülüklerin, Alt İşleyici tarafından da
yerine getirilmesini sağlayacak, işbu sayılanlara aykırı davranılması halinde
ortaya çıkacak tüm zararlardan tamamen sorumlu olacak ve işbu zararları Veri
Sorumlusu'nun ilk talebi üzerine derhal, nakden ve defaten tazmin edecektir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>4. Veri İşleyen'in Diğer Yükümlülükleri</span></b></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>4.1 Veri İşleyen'in Üstlendiği Güvenlik Tedbirleri. Veri
İşleyen, Kişisel Veri'yi Veri Vakası'na karşı korumak adına uygun tüm teknik,
kurumsal ve idari güvenlik tedbirlerini yerine getireceğini ve bunları idame
ettireceğini kabul ve taahhüt etmektedir. Söz konusu tedbirler, Kişisel
Veri'nin yeterli bir şekilde korunması için KVKK dahil ancak bununla sınırlı olmaksızın,
asgari olarak uygulanabilir ulusal ve uluslararası mevzuat uyarınca öngörülen
ve genel olarak geçerli kabul edilen korumayı sağlayacaktır.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>4.2 Veri İşleyen, Veri Sorumlusu tarafından Veri İşleyen'e
erişim yetkisi tanınan her türlü yazılımda, veri tabanında ve sistemde yer alan
Kişisel Veri'lerin hukuka aykırı şekilde işlenmesinin engellenmesinden, Kişisel
Veri'lere hukuka aykırı şekilde erişilmesinin engellenmesinden ve Kişisel
Veri'lerin hukuka uygun muhafaza edilmesinden tamamen sorumlu olacak ve işbu
hükümde sayılan yükümlülüklerin yerine getirilmesi için gereken tüm teknik ve
idari tedbirleri alacaktır. Veri İşleyen, Alt İşleyici'nin de bu hüküm
kapsamında sayılan ve gerekli olan tüm teknik ve idari tedbirleri almasını
sağlanmasından sorumlu olacaktır.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>4.3 Veri Vakası Bildirimi</span></b></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>Veri İşleyen,</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(i) İşbu Sözleşme kapsamında elde edilmiş ve işlenecek olan her
türlü Kişisel Veri'nin, söz konusu Kişisel Veri'yi işlemeye başlamadan önce,
güvenliğini ve gizliliğini temin etmek adına elinden gelen en iyi çabayı
göstereceğine ve işbu Sözleşme kapsamında elde edilmiş ve işlenecek olan
herhangi bir Kişisel Veri'ye ilişkin olarak bir Veri Vakası ile karşılaşmamak
adına uygun tüm teknik, kurumsal ve idari tedbirleri gerçekleştireceğini ve
idame ettireceğini;</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(ii) sunulan hizmet kapsamında işlediği herhangi bir Kişisel
Veri'yi etkileyen bir Veri Vakası'ndan haberdar olduğu takdirde Veri
Sorumlusu'nu derhal yazılı olarak:</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>a) Veri Vakası'nın niteliği ve eğer mümkün ise söz konusu Veri
Vakası'ndan etkilenen Veri Sahibi kategorileri ve sayısı hakkında,</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>b) Veri Vakası'ndan etkilenen (veya etkilenebilecek olan)
Kişisel Veri'ler ile söz konusu Kişisel Veri'lerin tahmini sayısı hakkında,</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>c) Veri Vakası'nın Kişisel Veri'ler ile Veri Sahibi kişiler
üzerindeki kesinleşmiş ve tahmini neticeleri hakkında,</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>d) Kişisel Veri'leri Veri Vakası'nın olumsuz etkilerinden
korumak, Veri Vakası'nın olumsuz etkilerini kısıtlamak, azaltmak veya gidermek
adına almış olduğu ve alacağı tüm tedbirler hakkında ve</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>e) Veri Sorumlusu'na yapmış olduğu Veri Vakası bildiriminin
derhal akabinde sürekli olarak ulaşılabilir olacağı telefon numarası hakkında
bilgilendireceğini;</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(iii) söz konusu Veri Vakası'nın olumsuz etkilerinin
kısıtlanması, azaltılması veya giderilmesi adına ve söz konusu Veri Vakası'ndan
kaynaklanan herhangi bir zararın en aza indirgenmesi adına derhal gerekli tüm
adımları atacağını ve Alt İşleyici'nin de derhal gerekli tüm adımları atmasını
sağlayacağını;</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(iv) Veri Sorumlusu'nu, Veri Vakası'nın olumsuz etkilerini
kısıtlamak, azaltmak veya gidermek adına attığı tüm adımların gidişatıyla
alakalı olarak düzenli aralıklarla bilgilendireceğini ve Veri Sorumlusu'nun
talebi üzerine gerekli tüm diğer bilgileri de sağlayacağını ve iş birliği
içerisinde hareket edeceğini ve Alt İşleyici'nin de işbirliği içerisinde
hareket etmesini sağlayacağını;</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(v) Veri Sorumlusu'nu, Kişisel Veri'ye, Veri İşleyen veya
İşleyici tarafından işlendiği sırada, bir iflas hali veya tasfiye durumu veya
üçüncü taraflarca alınan benzer tedbirler sırasında el konulması veya el
konulma tehdidinin bulunması halinde ivedi bir şekilde bilgilendireceğini;</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(vi) Veri Sorumlusu'nun işbu Sözleşme kapsamında soru ve
taleplerine mümkün olan en kısa sürede cevap vereceğini ve;</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>(vii) Kurul'un Kişisel Veri'nin işlenmesine dair kararlarına ve
görüşlerine uyacağını kabul, beyan ve taahhüt etmektedir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>4.4 Üçüncü Taraflara İfşa. Veri İşleyen, Veri Sorumlusu'nun
yazılı izni olduğu durumlar yasal olarak bağlayıcı bir işlem, talep veya emir
(örneğin bir mahkeme celbi, tutuklama emri veya mahkeme kararı) kapsamında
gerekli olduğu durumlar hariç olmak üzere, Kişisel Veri'yi hiçbir üçüncü tarafa
(herhangi bir kamu kurumu veya mahkeme dahil) ifşa etmeyecek ve Alt
İşleyici'nin de ifşa etmemesini sağlayacaktır. Üçüncü bir taraf, Kişisel
Veri'ye erişme veya Kişisel Veri'yi düzeltme talebinde bulunduğu takdirde Veri
İşleyen ve Alt İşleyici, söz konusu talebi reddedecek, söz konusu üçüncü tarafı
Kişisel Veri'ye ilişkin taleplerini Veri Sorumlusu'na yöneltmesi konusunda
bilgilendirecek ve söz konusu üçüncü tarafa Veri Sorumlusu'nun iletişim
bilgilerini sağlayacaktır. Veri İşleyen ve Alt İşleyici, Kişisel Veri'yi adli
makam ve yasal otorite gibi üçüncü bir tarafa ifşa etmek zorunda kaldığı
takdirde, erişime olanak sağlamadan önce Veri Sorumlusu'nu (Alt İşleyici aynı
zamanda Veri İşleyen'i), Veri Sorumlusu'nun koruyucu bir tedbir veya uygun
çözüm bulmasına olanak sağlamak adına, işbu erişime ilişkin en kısa sürede
bilgilendirecektir. İşbu bildirim hukuken yasaklanmış olduğu takdirde, Veri
İşleyen ve Alt İşleyici, Kişisel Veri'nin, usulsüz bir şekilde ifşa
edilmesinden korumak adına, kendisine ait gizli bilgiler talep ediliyormuş gibi,
makul tüm tedbirleri alacak ve Veri Sorumlusu'nu hukuki yasaklılık ortadan
kalkarsa ve kalktığı takdirde, mümkün olan en kısa sürede derhal
bilgilendirecektir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>4.5 Veri İşleyen'in Çalışanları. Veri İşleyen, çalışanlarının
yetkisiz bir şekilde Kişisel Veri'yi işlemesini engelleyecektir. Aynı
doğrultuda Veri İşleyen, çalışan veya Alt İşleyici'ye herhangi bir yazılım,
veri tabanı ve sistemlerde erişim sağlanması halinde, söz konusu erişimin yetki
matrisini özen ve ihtimam dahilinde belirleyeceğini; erişim yetkisi tanınan
kişiye özel ve gizli bir şifre belirleyeceğini; oluşabilecek tüm siber
saldırılara karşı alınacaklar dahil ancak bununla sınırlı olmaksızın yazılımın,
veri tabanının ve sistemin güvenli bir şekilde kullanımı için gerekli tüm
teknik ve idari tedbirleri alacağını kabul, beyan ve taahhüt etmektedir. Veri
İşleyen çalışanlarına ve Alt İşleyici'ye, gizliliğe, Kişisel Veri'nin
korunmasına ve Kişisel Veri güvenliğine ilişkin ilgili yükümlülükler de dahil
olmak üzere, uygun sözleşmesel yükümlülükler getirecektir. Bu minvalde Veri
İşleyen, çalışanının kişisel verilerin korunması ile işbu Sözleşme, Asıl
Sözleşme ve KVKK dahil ancak bununla sınırlı olmaksızın ilgili mevzuat
hükümlerine aykırı davranması ve işbu hususta Veri Sorumlusu nezdinde bir zarar
doğması halinde, işbu durumdan sorumlu olacağını kabul ve beyan eder. Veri
İşleyen, Kişisel Veri'ye erişimi olan tüm çalışanlarının, işledikleri Kişisel
Veri'ye ilişkin koruma sorumluluklarını anlamaları adına uygun bir eğitim
sürecinden geçmelerini temin edecektir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>5. Tazminat</span></b></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>Veri İşleyen yürüttüğü veri işleme faaliyetleri kapsamında Veri
Sorumlusu'nun üçüncü taraflara karşı yükümlülüklerini göz önünde
bulunduracaktır. Veri İşleyen'in herhangi bir Veri Vakası'nın oluşmasına
sebebiyet vermesiyle Veri Sorumlusu'nun herhangi bir para cezası, maddi ve
manevi tazminat veya her ne şekilde olursa olsun ödeme yapmakla yükümlü
kılınması ya da söz konusu Veri Vakası'nın Veri Sorumlusu nezdinde herhangi bir
zarara yol açması halinde; Veri Sorumlusu, söz konusu Veri Vakası'ndan dolayı
uğradığı zararı kesinleşmiş mahkeme kararı olmaksızın Veri İşleyen'e rücu
edebilecek ve bu durumda Veri İşleyen, Veri Sorumlusu'nun tüm zararlarını
derhâl, nakden ve defaten tazmin edecektir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>6. Teknik, Kurumsal ve İdari Tedbirlerin Denetlenmesi</span></b></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>6.1 Veri Sorumlusu Tarafından Denetim. Veri İşleyen, Veri
Sorumlusu'nun (veya atanmış temsilcilerinin) veya Veri Sorumlusu adına (Veri
İşleyen'in rakibi olmayacak) bağımsız bir üçüncü tarafın, makul bir bildirim
üzerine, olağan iş saatleri sırasında ve Veri İşleyen'in ticari faaliyetlerini
aksatmaya uğratmaksızın, Veri İşleyen'in Kişisel Veri'yi işleyişini ve Veri
İşleyen tarafından gerçekleştirilen ve idame ettirilen teknik, kurumsal ve
idari tedbirleri (veri işleme sistemleri, politikaları, süreçleri ve kayıtları
da dahil olmak üzere) inceleyip denetleyebileceğini ve Veri İşleyen'in bu
hususa ilişkin olarak imkan ve gerekli kolaylığı sağlayacağını kabul ve taahhüt
etmektedir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>6.2 Alternatif Denetim. Veri Sorumlusu tarafından veya Veri
Sorumlusu adına gerçekleştirilebilecek denetlemeye alternatif olarak Veri
İşleyen Veri Sorumlusu'na, ulusal ve uluslararası düzeyde kabul edilebilir
harici sertifikalar (örneğin ISO 27001:2013 vs.), denetleme raporları özetleri
ve/veya Veri İşleyen'in işbu Sözleşme'nin 4.2'inci maddesinde geçen teknik,
kurumsal ve idari tedbirlere yeterli ölçüde uyum sağladığını Veri Sorumlusu'na
teyit edebileceği diğer belgeler sağlayabilecektir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>6.3 Kişisel Veri'leri Koruma Otoriteleri Tarafından Denetim.
Veri İşleyen, Veri İşleyen'in işbu Sözleşme kapsamındaki yükümlülüklerine
yerine getirmek adına işlediği Kişisel Veri'ye ilişkin olarak ulusal veri
koruma otoriteleri tarafından aldığı tüm talepleri derhal Veri Sorumlusu'na
yönlendirecektir. Veri İşleyen, Veri Sorumlusu'nun ulusal veri koruma
otoriteleri ile muamelelerinde ve ulusal veri koruma otoriteleri tarafından
gelen her türlü denetleme talebinde Veri Sorumlusu ile iş birliği yapacağını
taahhüt etmektedir. Veri İşleyen, bir veri koruma otoritesi tarafından bir
talep aldığı takdirde, işbu Sözleşme'nin veya Veri Sorumlusu ve/veya Alt
İşleyici'ler ile işbu Sözleşme veya Asıl Sözleme(ler) kapsamında
yükümlülükleriyle alakalı mutabık kalınan veri korumasına ilişkin herhangi
diğer hükümlerin (ticari bilgiler hariç tutulabilir) ifşa edilmesine itiraz
etmeyecektir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>7. Gizlilik</span></b></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'> İşbu Sözleşme'nin 5.3'üncü maddesinde düzenlenen ulusal veri
koruma otoritelerinin resmi taleplerine uyum sağlama zorunluluğuna halel
gelmeksizin, Veri İşleyen, işbu Sözleşme'nin içeriğinin kamuya açık olmadığını,
Veri Sorumlusu'nun gizli bilgilerini içerdiğini ve Veri Sorumlusu'nun önceden
yazılı izni olmadan herhangi bir üçüncü tarafa ifşa etmeyeceğini kabul
etmektedir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>8. Sözleşme'nin Bütünlüğü ve Bağımsızlığı</span></b></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>İşbu Sözleşme'nin akdedilmesi ile halihazırda yürürlükte olan
veri işleme sözleşmesi var ise yürürlükten kaldırılmıştır. İşbu Sözleşme (ve
Asıl Sözleşme) konusu itibarıyla Taraflar arasındaki tüm anlaşma ve mutabakatı
teşkil etmektedir. Hiçbir Taraf işbu Sözleşme'yi, diğer Taraf'ın işbu
Sözleşme'de açıkça belirtilmeyen önceki veya eş zamanlı beyanına, sözüne veya
taahhüdüne (gerek ihmal olmadan gerekse ihmalkâr bir şekilde) dayanarak
akdetmemiştir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>9. Sözleşme Hükümlerinin Geçerlilik Süresi</span></b></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'> Taraflar, işbu Sözleşme ile tesis edilen yükümlülüklerin
tamamının, işbu Sözleşme'nin ve/veya Asıl Sözleşme'nin yürürlük ve/veya
geçerlilik süresinden bağımsız olduğunu ve işbu Sözleşme ve/veya Asıl Sözleşme
feshedilse veya herhangi başka bir sebepten dolayı sona erse dahi yürürlükte
kalacağını kabul ve beyan etmektedirler.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>10. Üçüncü Taraf Hakları</span></b></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'> İşbu Sözleşme, üçüncü kişilerin KVKK'dan kaynaklanan haklarına
halel getirmeksizin, Taraf'ı olmayan hiçbir kişiye herhangi bir hak veya
menfaat tanımamaktadır.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>11. Uygulanacak Hukuk</span></b></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'> İşbu Sözleşme, kanunlar ihtilafına bakılmaksızın, Türkiye
Cumhuriyeti yasalarına göre yorumlanacak ve tatbik edilecektir. İşbu
Sözleşme'den doğan veya kaynaklanan herhangi bir uyuşmazlık, münhasıran
İstanbul (Merkez) Çağlayan Adliyesi ve İcra Daireleri tarafından
çözümlenecektir.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><b><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>12. Öncelik</span></b></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'> İşbu Sözleşme'nin uygulama alanına giren hallerde işbu
Sözleşme'nin hükümleri ile Taraflar arasında yapılmış ve/veya yapılacak
sözleşme hükümleri arasında ihtilaf çıktığında işbu Sözleşme hükümleri
öncelikle uygulanır.</span></p>

                <p class=MsoNormal style='margin-bottom:7.5pt;line-height:19.2pt;background:
white'><span style='font-size:12.0pt;font-family:"Source Sans Pro","sans-serif";
color:#777777'>Taraflar, on iki (12) maddeden oluşan işbu Sözleşme'yi özgür
iradeleri çerçevesinde akdedilmiştir. İşbu Sözleşme'den kaynaklı damga vergisi
Taraflarca eşit olarak karşılanacaktır.</span></p>

                <p class=MsoNormal><span style='font-family:"Source Sans Pro","sans-serif"'>&nbsp;</span></p>

        </div>
</div>`;